import { produce } from "immer";
import { getCurrentWeek } from "../../utils/dates";
import {
  //
  ADD_BUDGET,
  ADD_BUDGET_FAILURE,
  ADD_BUDGET_SUCCESS,
  //
  BULK_UPDATE,
  BULK_UPDATE_FAILURE,
  BULK_UPDATE_SUCCESS,
  //
  COPY_BUDGET,
  COPY_BUDGET_FAILURE,
  COPY_BUDGET_SUCCESS,
  //
  DELETE_BUDGET,
  DELETE_BUDGET_FAILURE,
  DELETE_BUDGET_SUCCESS,
  //
  EDIT_BUDGET,
  EDIT_BUDGET_FAILURE,
  EDIT_BUDGET_SUCCESS,
  FETCH_BUDGET,
  FETCH_BUDGET_FAILURE,
  FETCH_BUDGET_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  SET_WEEK,
  TOGGLE_BUDGET_CONFIRM,
  //
  GET_BUDGET_HISTORY,
  GET_BUDGET_HISTORY_SUCCESS,
  GET_BUDGET_HISTORY_FAILURE,
  //
  TOGGLE_BUDGET_MODAL,
  TOGGLE_ADD_MODAL,
  TOGGLE_COPY_MODE,
  SET_COPY_DATA,
} from "./constants";

export const initialState = {
  isFetchingBudget: false,
  budgetList: [],
  // Add / Edit
  isSubmitting: false,
  isAddingBudget: false,
  // View
  isFetching: false,
  currentBudget: {},
  // Delete
  isDeleting: false,
  week: getCurrentWeek(),
  //
  budgetConfirm: {
    open: false,
  },
  isFetchingHistory: false,
  budgetHistory: [],
  //
  budgetModel: {
    open: false,
    budgetId: "",
  },
  addModal: {
    open: false,
    isEditing: false,
  },
  copyMode: "none",
  copyData: {},
  isCopying: false,
};

const BudgetReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_BUDGET:
        draft.isFetchingBudget = true;
        draft.currentBudget = {};
        draft.budgetList = [];
        break;
      case FETCH_BUDGET_SUCCESS:
        draft.isFetchingBudget = false;
        draft.budgetList = action.payload;
        break;
      case FETCH_BUDGET_FAILURE:
        draft.isFetchingBudget = false;
        draft.budgetList = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentBudget = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentBudget = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentBudget = {};
        break;
      // Add
      case ADD_BUDGET:
        draft.isAddingBudget = true;
        break;
      case ADD_BUDGET_SUCCESS:
        draft.isAddingBudget = false;
        break;
      case ADD_BUDGET_FAILURE:
        draft.isAddingBudget = false;
        break;
      // Edit
      case EDIT_BUDGET:
        draft.isSubmitting = true;
        break;
      case EDIT_BUDGET_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_BUDGET_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_BUDGET:
        draft.isDeleting = true;
        break;
      case DELETE_BUDGET_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_BUDGET_FAILURE:
        draft.isDeleting = false;
        break;

      case SET_WEEK:
        draft.week = action.payload;
        break;

      case TOGGLE_BUDGET_CONFIRM:
        draft.budgetConfirm = action.payload;
        break;

      case COPY_BUDGET:
        draft.isCopying = true;
        break;
      case COPY_BUDGET_SUCCESS:
        draft.isCopying = false;
        break;
      case COPY_BUDGET_FAILURE:
        draft.isCopying = false;
        break;

      case BULK_UPDATE:
        draft.isSubmitting = true;
        break;
      case BULK_UPDATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case BULK_UPDATE_FAILURE:
        draft.isSubmitting = false;
        break;

      case GET_BUDGET_HISTORY:
        draft.isFetchingHistory = true;
        draft.budgetHistory = [];
        break;
      case GET_BUDGET_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.budgetHistory = action.payload;
        break;
      case GET_BUDGET_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.budgetHistory = [];
        break;

      case TOGGLE_BUDGET_MODAL:
        draft.budgetModel = action.payload;
        break;

      case TOGGLE_ADD_MODAL:
        draft.addModal = action.payload;
        break;

      case TOGGLE_COPY_MODE:
        draft.copyMode = action.payload;
        break;

      case SET_COPY_DATA:
        draft.copyData = action.payload;
        break;

      default:
        return state;
    }
  });

export default BudgetReducer;
